module.exports = __webpack_public_path__ + "img/vps_video.700db70.png";